import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { RepresentativeService } from 'src/app/Service/Representative/Representative.service';

@Component({
  selector: 'app-RepresentativeList',
  templateUrl: './RepresentativeList.component.html',
  styleUrls: ['./RepresentativeList.component.scss']
})
export class RepresentativeListComponent implements OnInit {
  page:number=0;
  Procssing:boolean=false

  constructor(
    private Alertify_Service:AlertifyService,
    private Representative_Service:RepresentativeService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1101).subscribe(
      data=>{
        this.ReadData_Representative()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  DataList_Representative:Array<Customer_List_Interface>=[]
  ReadData_Representative(){
    this.Procssing=true

    this.Representative_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Representative=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Data_Seleted_Delete:any
  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  modalRef_Delete: any;
  Delete(item:Customer_List_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Representative_Service.DeleteRepresentative(item.id).subscribe(
      data=>{
        if(data['id']==-1)
          this.Alertify_Service.ErrorMessage("فعال سازی پیش از سه نماینده امکان پذیر نمی باشد")
        else if(item['del']==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")

        this.ReadData_Representative()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

}
